'use strict';

var categoryEntryFactory = require('./implementation/Category'),
    is = require('bpmn-js/lib/util/ModelUtil').is;

module.exports = function(group, element, translate) {

  if (!is(element, 'bpmn:Collaboration')) {

    var options;

    // name
    group.entries = group.entries.concat(categoryEntryFactory(element, options, translate));

  }

};
